// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3_erC","left":"InfoRow_left__3xY1L"};